import React from 'react';

const PaginationCurrent = ({ index }) => {
	return (
		<li className="mx-1" data-testid="pagination-button">
			<div
				className="pagination__list-item-link cursor-default flex justify-center items-center cta cta-secondary btn btn-secondary text-sm font-body text-center text-water bg-white rounded border-gray-40 p-0"
				data-testid="pagination-current">
				{index}
			</div>
		</li>
	);
};

export default PaginationCurrent;
